import Request from "../../utils/Request";
import {AxiosResponse} from "axios";



const CheckIsSuper = (data: any[] = false): Promise<AxiosResponse<T>> =>Request
	.get(`/advisors/my-user/get-super/`);


export default CheckIsSuper;